<template>
  <div>
    <el-form
      :model="form"
      :rules="rules"
      ref="form"
      label-width="120px"
    >
      <el-form-item label="我的需求是：" prop="demandDescribe">
        <el-input v-model="form.demandDescribe" :maxlength="500" type="textarea" :autosize='{ minRows: 4, maxRows: 6 }' placeholder="请输入您的需求"></el-input>
      </el-form-item>
      <el-form-item label="服务场地：" prop="address">
        <el-select v-if="provinceList" v-model="form.province" placeholder="请选择省" @change="handleProvinceChoose" style="margin-right: 20px;">
          <el-option
            v-for="(item, index) in provinceList"
            :key="index"
            :label="item.name"
            :value="`${item.codeP}`">
          </el-option>
        </el-select>
        <el-select :disabled="!form.province" v-model="form.city" placeholder="请选择市" @change="handleCityChoose" style="margin-right: 20px;">
          <el-option
            v-for="(item, index) in cityList"
            :key="index"
            :label="item.name"
            :value="`${item.codeC}`">
          </el-option>
        </el-select>
        <el-select :disabled="!form.city" v-model="form.area" placeholder="请选择区" @change="handleAreaChoose">
          <el-option
            v-for="(item, index) in areaList"
            :key="index"
            :label="item.name"
            :value="`${item.codeA}`">
          </el-option>
        </el-select>
        <br>
        <el-input type="textarea" autosize :maxlength="200" placeholder="请输入详细地址信息" v-model="form.address"></el-input>
      </el-form-item>
      <el-form-item label="附件：" prop="region">
        <el-upload
          class="upload-demo"
          :action="action"
          :before-remove="removeFile"
          :on-success="successFile"
          :on-error="errorFile"
          ref="upLoadFile"
          multiple
          :data="{ fileSuffixType: 'allType' }"
          :accept="'.jpg,.jpeg,.png,.gif,.bmp,.xls,.xlsx,.doc,.docx,.csv,.txt,.pdf,.zip,.rar,.ppt,.pptx'"
          :before-upload="beforeUpload"
          :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">上传文件不超过100MB</div>
        </el-upload>
      </el-form-item>
    </el-form>
    <div>
      <div class="title">
        我们将通过以下方式联系您
      </div>
      <div class="row">
        <el-row>
          <el-col :span="12">
            <label class="label">联系人： </label><span class="value">{{userInfo.contacts}}</span>
          </el-col>
          <el-col :span="12">
            <label class="label">联系方式： </label><span class="value">{{userInfo.contactNumber}}</span>
          </el-col>
        </el-row>
      </div>
      <div class="row">
        <el-row>
          <label class="label">企业名称： </label><span class="value">{{userInfo.componeny}}</span>
        </el-row>
      </div>
    </div>
    <div class="submit">
      <el-button @click="clickGoBack">返回</el-button>
      <el-button type="primary" :loading="subLoading" @click="submitHandle">提交</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'addDemand', // 用户新增需求
  data () {
    var validateAddress = (rule, value, callback) => {
      if (!this.form.province) {
        callback(new Error('服务场所在省份不能为空'))
      } else if (!this.form.city) {
        callback(new Error('服务场所在市不能为空'))
      } else if (!this.form.area) {
        callback(new Error('服务场所在区域不能为空'))
      } else {
        callback()
      }
    }
    return {
      action: window.SITE_CONFIG['apiURL'] + '/front/fileupload/alioss/v2/upload',
      form: {
        demandDescribe: '',
        province: '',
        city: '',
        area: '',
        address: ''
      },
      provinceList: [],
      cityList: [],
      areaList: [],
      userInfo: {
        contactNumber: this.$store.state.user.mobile,
        contacts: this.$store.state.user.name,
        componeny: this.$store.state.user.defaultCompanyName,
        companyId: this.$store.state.user.defaultCompanyId
      },
      rules: {
        demandDescribe: { required: true, message: '请输入需求内容', trigger: 'blur' },
        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur' },
          { validator: validateAddress, trigger: 'blur' }
        ]
      },
      fileList: [],
      subLoading: false
    }
  },
  methods: {
    submit () {
    },
    // 选中省
    handleProvinceChoose (value) {
      // this.form.province = value.slice(0, this.province.indexOf('%'))
      // this.codeP = value.slice(this.province.indexOf('%') + 1)
      // this.city = ''
      this.cityList = null
      // this.area = ''
      this.areaList = null
      this.form.area = ''
      this.form.city = ''
      // this.codeC = ''
      // this.codeA = ''
      this.getCity()
    },
    // 选中市
    handleCityChoose (value) {
      // this.form.city = this.city.slice(0, this.city.indexOf('%'))
      // this.codeC = this.city.slice(this.city.indexOf('%') + 1)
      // this.area = ''
      this.areaList = null
      this.form.area = ''
      // this.codeA = ''
      this.getArea()
    },
    // 选中区
    handleAreaChoose (value) {
      // this.form.area = this.area.slice(0, this.area.indexOf('%'))
      // this.codeA = this.area.slice(this.area.indexOf('%') + 1)
    },
    // 获取省列表
    getProvince () {
      this.$http.post(`${window.SITE_CONFIG['apiURL']}/help/sys/sysProvince/queryList`)
        .then(({ data }) => {
          if (data.code === 0) {
            this.provinceList = data.data
          }
        })
        .catch(() => {
          this.provinceList = []
        })
    },
    // 获取市列表
    getCity () {
      this.$http.post(`${window.SITE_CONFIG['apiURL']}/help/sys/sysCity/queryList`, {
        codeP: this.form.province
      })
        .then(({ data }) => {
          if (data.code === 0) {
            this.cityList = data.data
          }
        })
        .catch(() => {
          this.cityList = []
        })
    },
    // 上传失败
    errorFile () {
      this.subLoading = false
    },
    // 上传成功
    successFile (response, file, fileList) {
      if (response.code === 0) {
        this.fileList.push({
          uid: file.uid,
          ossId: response.data.aliOssId,
          ossName: response.data.objectName,
          url: response.data.url,
          name: response.data.fileName
          // uploadId: checkpoint.uploadId
        })
        this.subLoading = false
      } else {
        // console.log(this.$refs.upLoadFile.onRemove(file, fileList), file)
        // file.onError(file)
        this.$refs.upLoadFile.abort(file) // upload: el-upload的ref值；file:File类型，file文件本身
        fileList.splice(fileList.indexOf(file), 1) // fileList: 文件列表，钩子函数中的fileList
        this.removeFile(file, fileList)
        this.$message.error(response.msg || '上传失败')
        this.subLoading = false
      }
    },
    // 上传
    beforeUpload (file) {
      if (this.subLoading) {
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 100
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 100MB!')
        return false
      }
      let newName = file.name.slice(0, file.name.lastIndexOf('.'))
      let regx = /^[\u4E00-\u9FA5A-Za-z0-9]+$/
      if (regx.test(newName)) {
      } else {
        this.$message.warning('文件名只能由数字、英文字母、汉字组成，不能有空格 + 《 》等特殊符号')
        return false
      }
    },
    // 删除文件
    removeFile (file) {
      if (this.subLoading) {
        return false
      }
      if (file.ossId) {
        let index = this.fileList.findIndex(item => {
          return item.uid === file.uid
        })
        if (index > -1) {
          this.$http.post(`${window.SITE_CONFIG['apiURL']}/help/fileupload/sys/deleteBatchAliOss`, [this.fileList[index].ossId])
            .then(item => {
              this.fileList.splice(index, 1)
            })
            .catch(() => {
            })
        }
      }
    },
    // 获取区列表
    getArea () {
      this.$http.post(`${window.SITE_CONFIG['apiURL']}/help/sys/sysArea/queryList`, {
        codeC: this.form.city
      })
        .then(({ data }) => {
          if (data.code === 0) {
            this.areaList = data.data
          }
        })
        .catch(() => {
        })
    },
    // 提交
    submitHandle () {
      if (this.subLoading) {
        return false
      }
      let _this = this
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.subLoading = true
          this.form.demandOssRelationEntityList = this.fileList.map(item => {
            return { aliOssId: item.ossId }
          })
          // this.form.id = this.demandId
          // this.form.contacts = this.username
          // this.form.contactNumber = this.mobile
          // this.form.demandTypeId = this.form.demandTypeIds[1]
          let params = {
            ...this.form,
            ...this.userInfo
          }
          params.province = this.provinceList.filter(item => {
            return item.codeP === params.province
          })[0].name
          params.city = this.cityList.filter(item => {
            return item.codeC === params.city
          })[0].name
          params.area = this.areaList.filter(item => {
            return item.codeA === params.area
          })[0].name
          this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/consumer/demand/save`, params)
            .then(({ data }) => {
              if (data && data.code === 0) {
                // this.subFlag = true
                this.$message({
                  message: '新增成功',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    _this.subLoading = false
                    _this.$router.go(-1)
                  }
                })
              } else {
                this.subLoading = false
              }
            })
            .catch(() => {
              this.subLoading = false
            })
        }
      })
    },
    clickGoBack () {
      if (!this.subLoading && this.fileList.length) {
        for (let index = 0; index < this.fileList.length; index++) {
          const element = this.fileList[index]
          this.removeFile(element)
        }
      }
      this.$router.go(-1)
    }
  },
  created () {
    this.getProvince()
  }
}
</script>

<style lang="scss" scoped>
.title {
  border-top: #ccc solid 1px;
  padding: 10px 0;
  font-size: 16px;
  font-weight: bold;
}
.row {
  padding: 0 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  .label {
    font-weight: bold;
  }
  .value {
    color: #a0a0a0
  }
}
.submit {
  width: 100%;
  text-align: center;
}
/deep/ .el-upload-list {
  max-width: 200px;
}
</style>
